// styles
require('./amazonGiftCardConsentModal.scss');
require('./amazonGiftCardConsentModal.override.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const OKModal = require('components/commons/OKModal/OKModal');
const {
    AMAZON_CONSENT_MODAL_OPENMARKETS_POLICY_PDF,
    AMAZON_CONSENT_MODAL_POLICY_LINK,
} = require('constants/accountAmazonGiftCard');
//@constant
const {
    AMAZON_CONSENT_MODAL_ACCEPT,
    AMAZON_CONSENT_MODAL_BACK,
    AMAZON_CONSENT_MODAL_CONTINUE,
    AMAZON_CONSENT_MODAL_POLICIES,
    AMAZON_CONSENT_MODAL_SHOW,
    ACTION_EVENT_VIEW,
    AMAZON_CONSENT_MODAL
} = require('constants/tagging');
//@utils
const {
    recordLinkV2
} = require("../../../utilities/tagging");

const { formatText } = require('core/i18n').i18n;

class AmazonGiftCardConsentModal extends React.Component {

    constructor(props) {
        super(props);
        this.handleConsentCheckboxChange = this.handleConsentCheckboxChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.state = {
            isCheckboxChecked: false
        };
    }

    componentDidMount(){
        const {
            showModal
        } = this.props;

        if(showModal){
            this.handleRecordLink(ACTION_EVENT_VIEW);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            showModal
        } = this.props;

        if(prevProps.showModal !== showModal && showModal){
            this.handleRecordLink(ACTION_EVENT_VIEW);
        }
    }

    handleRecordLink(etiquetaEvento) {
        const customData = ({
            categoriaEvento: AMAZON_CONSENT_MODAL,
            accionEvento: AMAZON_CONSENT_MODAL_SHOW,
            etiquetaEvento
        });
        recordLinkV2(customData);
    }

    handleSubmit() {
        const { handleSubmit } = this.props;
        this.handleRecordLink(AMAZON_CONSENT_MODAL_CONTINUE);
        handleSubmit();
    }

    handleCancel() {
        const { onCancelClick } = this.props;
        this.handleRecordLink(AMAZON_CONSENT_MODAL_BACK);
        onCancelClick();
    }

    handleConsentCheckboxChange(event) {
        this.setState({
            isCheckboxChecked: event.target.checked
        });
        if (event.target.checked) {
            this.handleRecordLink(AMAZON_CONSENT_MODAL_ACCEPT);
        }
    }

    buildLastDescription(splitMessage) {
        const splittedMessageList = splitMessage.split('%s');
        const injectedLinks = [
            AMAZON_CONSENT_MODAL_POLICY_LINK,
            AMAZON_CONSENT_MODAL_OPENMARKETS_POLICY_PDF
        ];

        const finalMessage = splittedMessageList.map((message, index) => {
            const replacement = this.buildLinkForNewTab(injectedLinks[index]);
            return message && (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return (
            <div className="amazon-consents-modal__last-description">
                <span>{finalMessage}</span>
            </div>
        );
    }

    buildLinkForNewTab(link) {
        const content = (
            <OKLink
                extraClass="amazon-consents-modal__pdf-link"
                modifier="emphasize"
                onClick={() => {
                    this.handleRecordLink(AMAZON_CONSENT_MODAL_POLICIES);
                    window.open(link);
                }}
                target="_blank"
            >
                {link}
            </OKLink>
        )
        return content;
    }

    buildEmailLink(link) {
        const content = (
            <a
                className="ok-link ok-link--emphasize amazon-consents-modal__link"
                target="_blank"
                href={`mailto:${link}`}
            >
                {link}
            </a>
        )
        return content;
    }

    buildModal() {
        const {
            showModal,
            isUpdatingUserConsent,
        } = this.props;
        const modalTitle = formatText('amazonConsentModal-modalTitle');
        const checkboxLabel = formatText('amazonConsentModal-checkboxText');
        const firstDescription = formatText('amazonConsentModal-firstDescription');
        const secondDescription = formatText('amazonConsentModal-secondDescription');
        const contactDataHeader = formatText('amazonConsentModal-contactDataHeader');
        const openBankLabel = formatText('amazonConsentModal-openBankLabel');
        const openBankEmail = formatText('amazonConsentModal-openBankPrivacyEmail');
        const openMarketLabel = formatText('amazonConsentModal-openMarketLabel');
        const openMarketEmail = formatText('amazonConsentModal-openMarketPrivacyEmail');
        const contactDescription = formatText('amazonConsentModal-contactDescription');

        const modalBody = (
            <div className="amazon-consents-modal__main-content">

                <i className="amazon-consents-modal__icon-consent"/>

                <div className="amazon-consents-modal__body-title">
                    <span>{modalTitle}</span>
                </div>

                <div className="amazon-consents-modal__description">
                    {firstDescription}
                </div>

                <div className="amazon-consents-modal__checkbox-container">
                    <OKCheckbox
                        idName="acceptConsentForAmazonGiftCard"
                        label={checkboxLabel}
                        onChange={this.handleConsentCheckboxChange}
                        value={this.state.isCheckboxChecked}
                    />
                </div>

                <span className="amazon-consents-modal__description">
                    {secondDescription}
                </span>

                <div className="amazon-consents-modal__contact-details">
                    <div>
                        <span className="amazon-consents-modal__description">
                            {contactDataHeader + ':'}
                        </span>
                    </div>

                    <div>
                        <span className="amazon-consents-modal__description">
                            {openBankLabel + ': '}
                        </span>
                        <span className="amazon-consents-modal__link">
                            {this.buildEmailLink(openBankEmail)}
                        </span>
                    </div>

                    <div>
                        <span className="amazon-consents-modal__description">
                            {openMarketLabel + ': '}
                        </span>
                        <span className="amazon-consents-modal__link">
                            {this.buildEmailLink(openMarketEmail)}
                        </span>
                    </div>

                    {this.buildLastDescription(contactDescription)}
                </div>

            </div>
        );
        return (
            <OKModal
                content={modalBody}
                footerType="navigation"
                isOpen={showModal}
                customCloseButton={<div/>}
                size="large"
                shouldCloseOnOverlayClick={false}
                onPrimaryButtonClick={this.handleSubmit}
                onSecondaryButtonClick={this.handleCancel}
                primaryButtonDisabled={!this.state.isCheckboxChecked}
                primaryButtonLoading={isUpdatingUserConsent}
                primaryButtonText="common-continue"
                secondaryButtonText="common-back"
                overlayClassName="amazon-consents-modal"
            />
        )
    }

    render() {
        return (
            <div>
                {this.buildModal()}
            </div>
        )
    }
}

AmazonGiftCardConsentModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    isUpdatingUserConsent: PropTypes.bool.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

module.exports = AmazonGiftCardConsentModal;
